// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2343":"6c614856","4036":"b854bf70","4891":"0d0a4478"}[chunkId] + ".chunk.css";
};